














































import {
  defineComponent,
  computed,
  PropType,
  getCurrentInstance
} from "@vue/composition-api";
import { closePopover, VTooltipEvent } from "@/helpers/v-tooltip-helper";
import { useElementSize } from "@/helpers/hooks/useElementSize";
import SelectBoxDropdownWrapper from "@/components/Atoms/SelectBoxDropdownWrapper/index.vue";
import { SelectItem } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "OccSelectbox",
  components: {
    SelectBoxDropdownWrapper
  },
  props: {
    selectList: {
      type: Array as PropType<SelectItem[]>,
      required: true
    },
    selectedValue: {
      type: [String, Number, Boolean],
      default: ""
    },

    placeholder: {
      type: String,
      default: ""
    },
    minWidth: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    selectboxDisabled: {
      type: Boolean,
      default: false
    },
    buttonDisabled: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const [selectboxRef, selectboxSize] = useElementSize<HTMLDivElement>();

    const selectListMinWidth = computed(() => selectboxSize.value.width);

    const instance = getCurrentInstance();
    const onClickListItem = (event: VTooltipEvent, item: SelectItem) => {
      closePopover(event);
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventLabel: {
            value: item.value,
            label: item.label
          }
        });
      }
      context.emit("change", item.value);
    };

    const selectedLabel = computed((): string => {
      const selectedItem = props.selectList.find(
        selectItem => selectItem.value === props.selectedValue
      );
      return selectedItem ? selectedItem.label : "";
    });

    return {
      selectboxRef,
      selectListMinWidth,
      selectedLabel,
      onClickListItem
    };
  }
});
